import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { amountFormatter, sortObject } from '/src/lib/helpers';
import { PENDING_INFO_TEXT, FUNDING_STATUS } from '/src/lib/constants';
import NewBadge from "/src/components/Reusable/NewBadge";

export const initiateTooltip = () => {
    if (typeof window.jQuery !== 'undefined') {
        $(function () {
            if (document.querySelectorAll('[data-toggle="tooltip"]') && $?.fn?.tooltip) {
                $('[data-toggle="tooltip"]').tooltip();
            }
        });
    }
};

export const getDate = (date) => {

    let content = 'N/A';

    if (date) {
        const dateObj = new Date();
        const options = {
            year: 'numeric',
            month: 'short',
        };

        dateObj.setFullYear(date.substr(0, 4));
        dateObj.setMonth(parseInt(date.substr(5, 2), 10) - 1);
        content = dateObj.toLocaleString("en-US", options);
    }

    return content;

}

export const getAmount = (amount) => {
    let content = "Undisclosed";
    if (amount) {
        content = amountFormatter(amount);
    }
    return content;
}

export const getStage = (stageData) => {
    // if (!isEmpty(stageData) && stageData.name) {
    //     return stageData.is_proxy
    //         ? <span className="amount--estimated">{stageData.name}</span>
    //         : stageData.name;
    // }
    // return 'N/A';
    return stageData?.name || 'Undisclosed';
}

// method to check if entity profile on display is the same on investedin_data
export const isFocusedEntity = (data, id, entityType) => {
    if (data.id === id && data.type.toLowerCase() === entityType.toLowerCase()) {
        return true;
    }
    return false;
}

// icon for verified round/breakdown
const verifiedIcon = (
    <span class="fa-stack icon-stack-verified">
        <i class="fa-stack-2x fa fa-circle"></i>
        <i class="fa-stack-1x fas fa-check fa-inverse"></i>
    </span>
)

// icon for pending verification for round/breakdown
const pendingIcon = (
    <span class="fa-stack icon-stack-pending">
        <i class="fa-stack-2x fa fa-circle"></i>
        <i class="fa-stack-1x fas fa-hourglass fa-inverse"></i>
    </span>
)

export const getVerificationIcon = (verificationStatus) => {
    const isVerified = (verificationStatus === FUNDING_STATUS.verified);
    if (isVerified) {
        return verifiedIcon;
    } else {
        return pendingIcon;
    }
}

// return verified if all verification_status of funding breakdowns in a funding round is equal to 1
export const allFBVerified = (fBData, notOwner) => {
    let allVerified = false;
    let tempId = 0;
    if (fBData && fBData.length) {
        tempId = fBData[0].funding_breakdown_id;
        allVerified = fBData.every(data => Number(data.verification_status) === FUNDING_STATUS.verified);
    }

    let tooltipMsg = '';
    if (allVerified) {
        tooltipMsg = 'Verified rounds have undergone thorough research and confirmation by a MAGNiTT team member, ensuring their existence and accuracy';
    } else {
        tooltipMsg = notOwner ? PENDING_INFO_TEXT.not_owner : PENDING_INFO_TEXT.owner;
    }

    // must set 'key', otherwise when page changes, React persists the verification label of the previous round
    if (allVerified) {
        return (
            <span className="secondary-label" role="button" data-toggle="tooltip" data-placement="right" title={tooltipMsg} key={`verified-label-${tempId}`}>
                Verified
            </span>
        )
    } else {
        return (
            <span className="secondary-label" role="button" data-toggle="tooltip" data-placement="right" title={tooltipMsg} key={`pending-label-${tempId}`}>
                Pending
            </span>
        )
    }
}

// return valuation data if valuation is available
export const viewRoundValuation = (valuation, notOwner) => {
    let valuationData = valuation && valuation.max ? true : false;
    let valuationEstimate = valuation && valuation.is_estimate ? true : false;
    let valuationLabel = valuationEstimate ? "Valuation Estimate" : "Valuation";

    let valuationMin = valuation && valuation.min ? getAmount(valuation.min) : '0';
    let valuationMax = valuationData ? getAmount(valuation.max) : null;

    if (valuationData) {
        return (
            <>
                <p>
                    <span className={valuationEstimate ? 'amount--estimated' : ''}>
                        {valuationMin} {valuationMax ? '-' : null} {valuationMax}
                    </span>
                </p>
                <p>{valuationLabel}</p>
            </>
        )
    } else {
        return (
            <>
                <p>N/A</p>
                <p>Valuation</p>
            </>
        )
    }
}

export const getTableTitle = (props, state) => {
    let title = null;
    let tableName = null;

    const { numberOfFundedStartups, numberOfFundingRounds, numberOfFundingBreakdowns, totalInvestmentAmount, numberOfInvestments } = state;
    const { isInvestorInvestments, isFundInvestment } = props;
    const totalAmount = props.totalFund;
    // check if total amount is greater than zero since it can be a string with $0 as zero
    const value = String(totalAmount)?.length > 2 ? (<>worth <b>{totalAmount}</b></>) : null;

    // get rounds count for display
    let investmentsCount = props.numberFunding;
    if (!investmentsCount) {
        investmentsCount = state.totalRecords;
    }

    // make common fields
    const name = props.name

    if (props.hideHeading) {
        title = null;
    } else if ((isFundInvestment || isInvestorInvestments)) {

        const type = isFundInvestment
            ? (numberOfFundedStartups > 1 ? 'Funds' : 'Fund')
            : (numberOfFundedStartups > 1 ? 'Companies' : 'Company');
        const displayCount = isInvestorInvestments ? numberOfInvestments : numberOfFundingRounds;
        const count = (<b>{displayCount}</b>);
        const entityCount = (<><b>{numberOfFundedStartups}</b> {type}</>)
        const totalAndEntityCount = totalInvestmentAmount
            ? (<>totalling <b>{totalInvestmentAmount}</b> across {entityCount}</>)
            : (<>across {entityCount}</>);

        title = (
            <>
                <h2 className="profile-section-heading">
                    {isFundInvestment && (
                        <>
                            Fund Investments
                            <NewBadge className="px-2" />
                        </>
                    )}
                    {isInvestorInvestments && (
                        <>
                        Direct Investments
                            <NewBadge className="px-2" />
                        </>
                    )}
                </h2>
                <h3>
                    {name} has made {count} investment{displayCount > 1 ? 's' : ''} {totalAndEntityCount}
                </h3>
            </>
        );
        tableName = 'Investments Funds Table'

    } else if (props.isInvestment || props.isStartupInvTable) {
        title = (
            <>
                <h2 className="profile-section-heading">
					Investments
                </h2>
                <h3>
                    {name} has made <b>{investmentsCount}</b> {' '}investment{investmentsCount > 1 ? 's' : ''} {value}
                </h3>
            </>
        );
    } else if (props.isFundingRounds) {
        title = (
            <>
                <h2 className="profile-section-heading">
					Funding Rounds
                </h2>
                <h3>
                    {name} has <b>{numberOfFundingBreakdowns}</b> funding round{numberOfFundingBreakdowns > 1 ? 's' : ''}  {value}
                </h3>
            </>
        );

    } else if (props.isStartupAcquisitions) {
        title = (
            <>
                <h2 className="profile-section-heading">Acquisitions</h2>
                <h3>{name} has acquired <b>{investmentsCount}</b> Startup{investmentsCount > 1 ? 's' : ''}</h3>
            </>
        );

    } else if (props.isManagedFunds) {
        title = (
            <>
                <h2 className="profile-section-secondary-heading">Funds Raised</h2>
                <h3>{name} has <b>{investmentsCount}</b> fund{investmentsCount > 1 ? 's' : ''} {value ? value : null}</h3>
            </>
        );

    } else if (props.isPortfolioExits) {
        title = (
            <>
                <h2 className="profile-section-heading">Portfolio Exits <NewBadge className="px-2" /></h2>
                <h3>{name} has made <b>{investmentsCount}</b> exit{investmentsCount > 1 ? 's' : ''}</h3>
            </>
        );
    }

    return ({ title, tableName })
}

// get entity country from array of funding breakdowns
export const getEntityCountry = (data) => {
    let country = "Country N/A";
    let fb = data.funding_breakdowns_data;

    if (fb && fb.length > 0) {
        fb = sortObject(fb, "date_raised"); // get latest breakdown
        if (fb[0].location_data && fb[0].location_data.name) {
            country = fb[0].location_data.name;
        }
    }
    return country;
}

// get deal term value from a single investor funding object
export const getDealTerms = (inv, list_dealTerm) => {
    let dealTerm = [];
    if (list_dealTerm && list_dealTerm.length !== 0) {
        list_dealTerm.map((deal) => {
            if (inv.deal_term_data && inv.deal_term_data.id) {
                if (deal.id == inv.deal_term_data.id) {
                    dealTerm.push(formatDealTerm(deal.name));
                }
            }
        })
    }

    if (dealTerm.length > 0) {
        return (dealTerm.map(deal => <p>{deal}</p>))
    } else {
        return (<p>N/A</p>)
    }
}

// format deal term text without the description in brackets
// e.g. KISS (Keep It Simple Securities) becomes KISS
const formatDealTerm = (name) => {
    if (name.includes('(')) {
        name = name.substring(0, name.indexOf('(')).trim();
    }
    return name;
}

// get display amount from a single investor funding object
export const getDisplayAmount = (inv, estimatedAmount, verificationStatus, showTooltip = false) => {
    let displayAmounts = [];

    let hasEstimatedAmount = false;

    let amount = "";
    if (inv.amount) {
        amount = inv.amount;
    } else if (inv.invested_amount) {
        amount = inv.invested_amount;
    } else if (estimatedAmount && Number(estimatedAmount) > 0) {
        amount = estimatedAmount;
        hasEstimatedAmount = true;
    }

    inv.displayAmount = `${getAmount(amount)}`;

    if (!inv.displayAmount) {
        return;
    }

    const isVerifiedAmount = (!hasEstimatedAmount && verificationStatus === FUNDING_STATUS.verified && !inv.displayAmount.includes('Undisclosed'));

    displayAmounts.push(
        <p>
            <span className={hasEstimatedAmount ? 'amount--estimated' : ''}>
                {inv.displayAmount}
            </span>
            {hasEstimatedAmount && showTooltip &&
                <i className="fas fa-info-circle pr-1 ml-1"
                    role="button"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="This amount is an estimate based on the round size, stage, and this investor's other investments"
                />
            }
            {isVerifiedAmount && showTooltip &&
                <i
                    className="fa fa-check pr-1 ml-1"
                    role="button"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Verified rounds have been confirmed by a MAGNiTT team member"
                />
            }
        </p>
    )

    if (displayAmounts.length > 0) {
        return (displayAmounts);
    } else {
        return (<p>N/A</p>)
    }
}
